import type {
  AbilityRecord,
  MetricAggregate,
} from "../../shared/api/generated/contracts";

export const METRIC_AGGREGATES: readonly MetricAggregate[] = [
  "count",
  "sum",
  "avg",
  "min",
  "max",
];

/**
 * Aggregate over the records. `count` counts records; the rest read numeric
 * values of `fieldId` and return null when there is nothing to aggregate
 * (avg, min, max) so the caller can show a placeholder. `sum` of nothing is 0.
 */
export function aggregate(
  records: readonly AbilityRecord[],
  kind: MetricAggregate,
  fieldId?: string,
): number | null {
  if (kind === "count") return records.length;
  const values = fieldId
    ? records.flatMap((record) => {
        const value = record.payload[fieldId];
        return typeof value === "number" && Number.isFinite(value)
          ? [value]
          : [];
      })
    : [];
  if (kind === "sum") return values.reduce((total, value) => total + value, 0);
  if (values.length === 0) return null;
  if (kind === "min") return Math.min(...values);
  if (kind === "max") return Math.max(...values);
  const mean =
    values.reduce((total, value) => total + value, 0) / values.length;
  return Math.round(mean * 10) / 10;
}
